import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material'
import gsap from 'gsap'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useAuth } from '../../hooks/useAuth'
import { toggleSideBar } from '../../store/reducers/display.reducer'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'


function AnimatedLogo({ open, onclose, isMenuHidden = false }: { isMenuHidden?: boolean, open: boolean, onclose: () => void }) {
    const { t } = useTranslation()
    const { auth, isUserFetching } = useAuth()
    const dispatch = useDispatch()

    const restricted = useSelector<RootState>(state => state.user.restrictedMode) as boolean

    const headerTitle = t('registration:email:subject', { username: auth?.firstname ?? '' }).split(' ')


    return (
        <Box width={'100%'} height={'47px'} display={'flex'} justifyContent={'space-between'} gap={0.5} alignItems={'center'} px={1} position={'relative'} zIndex={1}>

            {(auth && open) && <Stack direction={'row'} gap={0.5}>
                <Typography variant='subtitle1' fontWeight={'100'}>{headerTitle?.at(0)},</Typography>
                <Typography variant='subtitle1'>{headerTitle?.at(1)}</Typography>
            </Stack>}

            {
              (!isMenuHidden || !restricted)&& <IconButton
                    color="inherit"
                    onClick={() => {

                        dispatch(toggleSideBar(!open))
                        onclose()
                    }}
                    sx={{ zIndex: 1 }}
                >
                    {open ? <Icon icon='hugeicons:menu-03' /> : <Icon icon='hugeicons:menu-01' />}
                </IconButton>
            }



            <img alt='Arioneo Logo' id='logo' src='/logoArioneo.png' style={{ objectFit: 'contain', position: 'absolute', opacity: 0.15, top: -20, height: 80, overflow: 'hidden', left: -20, zIndex: 0 }}  ></img>
        </Box>
    )
}

export default AnimatedLogo